import i18next, { StringMap, TOptions } from 'i18next';

import languages from './languages';
import * as store from './store';

function t(key: string | Array<string>, options?: string | TOptions<StringMap>) {
    return i18next.t(key, options);
}

function keyExists(key: string | Array<string>) {
    return i18next.exists(key);
}

export { languages, store, t, keyExists };
